<template>
  <div class="image-list">
    <div class="image-item" v-for="(item, index) in srcList" :key="index">
      <template v-if="isPDF(item)">
        <img @click="previewPdf(item)" src="@/assets/public/pdf.png" alt="" style="width: 80%; height: 100%"/>
      </template>
      <template v-else>
        <el-image
          style="width: 100%; height: 100%"
          :src="item"
          :fit="fit"
          @click="previewImage(item, index)">
        </el-image>
      </template>
    </div>
    <bsp-image-preview :visible="visible" :src-list="imgList" @close-preview="closeViewer" :initial-index="initialIndex"></bsp-image-preview>
  </div>
</template>

<script>
  export default {
    name: "bsp-image",
    props: {
      srcList: {
        type: Array,
        default() {
          return [];
        }
      },
      fit: {
        type: String,
        default() {
          return "cover";
        }
      }
    },
    data() {
      return {
        imgList: [],
        visible: false,
        initialIndex: 0
      };
    },
    methods: {
      isPDF(item) {
        return item.toLowerCase().includes("pdf")
      },
      previewPdf(item) {
        window.open(item)
      },
      previewImage(url, index) {
        this.imgList = this.srcList.filter(item=> !item.includes("pdf"))
        this.initialIndex = index;
        if (this.srcList.includes("pdf")) {
          for (let i = 0; i < index; i++) {
            if (this.srcList[i].includes("pdf")) {
              this.initialIndex = this.initialIndex -1
            }
          }
        }
        this.visible = true;
      },
      closeViewer() {
        this.visible = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .image-list {
    display: flex;
    flex-wrap: wrap;
    .image-item {
      width: 100px;
      height: 100px;
      margin: 0 10px 10px 0;
      cursor: pointer;
    }
  }
</style>
